import { Spinner } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import Stopper from '../../../components/Stopper';
import { getEnv, managementEnvironment } from '../../../utils/dataTransformation/environments';

const Login: React.FC = () => {
    const loginDisabled = managementEnvironment().VITE_STOPPER_LOGIN_DISABLED;

    useEffect(() => {
        if (!loginDisabled) {
            const state = uuidv4();
            const nonce = uuidv4();
            window.sessionStorage.setItem('login-state', state);

            const baseUrl = getEnv('VITE_LOGIN_URL');

            const clientId = getEnv('VITE_CLIENT_ID');

            const redirect = getEnv('VITE_LOGIN_CALLBACK');

            if (!baseUrl || !clientId || !redirect) {
                console.warn('Missing login envs');
                return;
            }

            const sep = baseUrl.includes('?') ? '&' : '?';
            const url = `${baseUrl}${sep}client_id=${encodeURIComponent(
                clientId,
            )}&redirect_uri=${encodeURIComponent(redirect)}&state=${encodeURIComponent(
                state,
            )}&nonce=${encodeURIComponent(nonce)}`;

            window.location.href = url;
        }
    }, [loginDisabled]);

    if (loginDisabled) return <Stopper />;

    return (
        <>
            {isIOS && (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span className='c-spinner-overlay'></span>
                </div>
            )}
        </>
    );
};

export default Login;
